import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentProject: null,
  projects: [],
  loading: false,
  loaded: false,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setCurrentProject: (state, action) => {
      state.currentProject = action.payload;
      // Store the hash in localStorage
      if (action.payload) {
        localStorage.setItem('currentProjectHash', action.payload.hash);
      } else {
        localStorage.removeItem('currentProjectHash');
      }
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setProjectsLoaded: (state, action) => {
      state.loaded = action.payload;
    },
    clearProjectState: (state) => {
      state.currentProject = null;
      state.projects = [];
      state.loaded = false;
      localStorage.removeItem('currentProjectHash');
    },
  },
});

export const { setCurrentProject, setProjects, setLoading, setProjectsLoaded, clearProjectState } = projectSlice.actions;

export default projectSlice.reducer;

